/* eslint-disable no-await-in-loop */
<template>
  <el-card v-loading="loading" :body-style="{padding: 0, height: '20rem'}">
    <div class="rs-card-header">
      <h4 class="wallet-head">
        Current Member Collections
      </h4>
    </div>
    <el-table
      :data="collections"
      :header-cell-style="{padding: '0.25rem'}"
      :default-sort = "{prop: 'daysBehind', order: 'descending'}"
      max-height="290"
      @row-click="routeToCustomer"
    >
      <el-table-column
        prop="member.company"
        label="Member"
        width="200"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="totalAR"
        label="Past Due"
        width="120"
        sortable
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column
        prop="achTransaction"
        label="Pending ACH"
        width="150"
        sortable
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column
        prop="daysBehind"
        label="Days Old"
        width="120"
        sortable
      >
      </el-table-column>
      <el-table-column
        prop="unitNames"
        label="Units"
      >
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'FacilityOpenUnits',
  async mounted() {
    this.loading = true;
    await this.getFacilityCollections();
    this.loading = false;
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityCollections();
      this.loading = false;
    },
  },
  props: {
    facility: { type: String, required: true },
    height: { type: String, default: '290' },
    dashboard: { type: Boolean, default: () => false },
  },
  data() {
    return {
      collections: [],
      loading: true,
    };
  },
  methods: {
    async getFacilityCollections() {
      const response = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}/collections`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          leaseTypes: 'active-only-completed',
        },
      });

      const result = response.data.result;
      // eslint-disable-next-line no-restricted-syntax
      this.collections = result;
    },
    routeToCustomer(row) {
      console.log(row);
      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: row.member._id, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: row.member._id } });
    },
  },
};
</script>

<style scoped>
.wallet-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}
.rs-card-header {
  padding: 0.5rem;
  border-bottom: solid 1px #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/FacilityCollections.vue